export const getMaxTagPlaceholder = (omittedValues) => {
  if (omittedValues && omittedValues.length > 0) {
    return `+${omittedValues.length} Items`;
  }
};

export const getRequired = (isRadioGroup, selectedChoice, choiceLineValue, requiredItems) => {
  return isRadioGroup ? selectedChoice && selectedChoice === choiceLineValue : requiredItems.includes(choiceLineValue);
  // return isRadioGroup ? !selectedChoice || selectedChoice === choiceLineValue : requiredItems.includes(choiceLineValue);
};
